function Col({ children, className, ...rest }) {
  return (
    <div className={`column ${className || ''}`} {...rest}>
      {children}
    </div>
  );
}

export default Col;
